export default "__VITE_ASSET__BKdc6MOv__"